import { useEffect } from "react";
import { X } from "@phosphor-icons/react";
import { StatusPill } from "@/components/StatusPill";

// Read-only snapshot card. Click the backdrop (or press Esc) to dismiss.
export function QuickView({ title, subtitle, status, onClose, children, testId = "quick-view" }) {
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div className="fixed inset-0 bg-slate-900/60 flex items-center justify-center p-4 z-50" data-testid={testId} onClick={onClose}>
      <div className="bg-white rounded-md w-full max-w-lg p-6 border border-slate-200 shadow-xl max-h-[85vh] overflow-y-auto"
           onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="min-w-0">
            <div className="tinylabel">Quick view</div>
            <h2 className="text-xl font-bold break-words">{title}</h2>
            {subtitle && <div className="text-sm text-slate-500 mt-0.5">{subtitle}</div>}
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            {status && <StatusPill status={status} />}
            <button onClick={onClose} data-testid="quick-view-close" className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
          </div>
        </div>
        {children}
        <div className="mt-4 text-[11px] text-slate-400 text-center">Click outside the card (or press Esc) to close</div>
      </div>
    </div>
  );
}

export function QVRow({ label, value, mono }) {
  const display = value === 0 ? "0" : (value || "—");
  return (
    <div className="flex justify-between gap-6 py-2 border-b border-slate-100 last:border-none text-sm">
      <span className="text-[11px] font-bold uppercase tracking-widest text-slate-400 pt-0.5 flex-shrink-0">{label}</span>
      <span className={`text-right text-slate-800 min-w-0 break-words ${mono ? "font-mono" : ""}`}>{display}</span>
    </div>
  );
}

// Row-click guard: ignore clicks on interactive elements inside the row.
export function qvRowClick(e, open) {
  if (e.target.closest("button, a, input, select, label")) return;
  open();
}
